import React from 'react';
import styles from './_custom-field-editor.module.scss';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import { TabName } from '../Views/OrderEditor/OrderEditorTabs';
import { IApplicationCustomField } from '../../Interfaces/Application/IApplicationCustomField';
import { ComboBox, ComboBoxChangeEvent } from '@progress/kendo-react-dropdowns';
import { ICustomValuePair } from '../../Interfaces/Application/ICustomValuePair';
import { Input, SwitchChangeEvent } from '@progress/kendo-react-inputs';
import { Switch } from "@progress/kendo-react-inputs";
import InfoIcon from "@mui/icons-material/Info";
import Divider from '@mui/material/Divider';
export interface CustomFieldEditorProps {
  navigate: (tabName: TabName) => void;
  applicaitonCustomFields: IApplicationCustomField[];
  onUpdateApplicationCustomField(field: ICustomValuePair): void;
  onUpdateApplicationCustomField(field: ICustomValuePair): void;
}

export default function CustomFieldEditor(props: CustomFieldEditorProps) {
  return (
    <div className={styles.customFieldEditorContainer}>
      <Card>
        <CardHeader
          avatar={<InfoIcon fontSize="small" />}
          title="Custom Fields"
          action={
            <IconButton size="small" onClick={() => props.navigate && props.navigate("Custom Fields")}>
              <EditIcon fontSize="small" />
            </IconButton>
          }
        />
        <Divider variant="middle" />
        <div className={styles.customFieldsEditorContent}>
          {props.applicaitonCustomFields.map((acf: IApplicationCustomField) => {
            return (
              <div className={styles.customFieldEditorRow}>
                <div className={styles.customFieldEditorLabel}>
                  <span>{acf.customField.name}</span>
                  <div className={styles.switch}>
                    <span style={{marginRight: '10px'}}>Auto</span>
                    <Switch
                      checked={acf.isAutomaticallyCalculated}
                      disabled={acf.customField.isReadonly}
                      onChange={(event: SwitchChangeEvent) => {
                        props.onUpdateApplicationCustomField({customFieldName: acf.customField.name, formattedValue: event.value, valueType: 'isAutomaticallyCalculated'});
                      }}
                    />
                  </div>
                </div>
                <div className={styles.customFieldEditorInput}>
                  {acf.customField.customFieldOptions && acf.customField.customFieldOptions?.length > 0 && (
                      <ComboBox
                        // label={'Loan Class'}
                        disabled={acf.isAutomaticallyCalculated}
                        data={acf.customField.customFieldOptions}
                        textField="name"
                        suggest={true}
                        clearButton={false}
                        value={acf.customField.customFieldOptions.find(cfo => cfo.name === acf.value)}
                        onChange={(event: ComboBoxChangeEvent) => {
                          props.onUpdateApplicationCustomField({ customFieldName: acf.customField.name, formattedValue: event.value?.name, valueType: 'value' })
                        }}
                      />
                  )}
                  {!acf.customField.customFieldOptions || acf.customField.customFieldOptions.length === 0 && (
                    <Input
                      maxLength={1000}
                      disabled={acf.isAutomaticallyCalculated}
                      placeholder='value...'
                      value={acf.value}
                      onChange={(event: any) => {
                        props.onUpdateApplicationCustomField({ customFieldName: acf.customField.name, formattedValue: event.value, valueType: 'value' })
                      }}
                    />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </Card>
    </div>
  );
}
